import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import classnames from "classnames";
import './page-selector.css';
import Locker from '../Locker';
import Errorer from '../Errorer';

function PageThumbnail(_ref) {
  var _metadata$find, _metadata$find$call;

  var src = _ref.src,
      isActive = _ref.isActive,
      onClick = _ref.onClick,
      metadata = _ref.metadata,
      showMetadata = _ref.showMetadata,
      imageIndex = _ref.imageIndex,
      imageId = _ref.imageId,
      onMetadataChange = _ref.onMetadataChange,
      _ref$metadataConfigs = _ref.metadataConfigs,
      metadataConfigs = _ref$metadataConfigs === void 0 ? [] : _ref$metadataConfigs,
      isLocked = _ref.isLocked,
      error = _ref.error,
      onRecalcClick = _ref.onRecalcClick,
      _ref$isRecalcReady = _ref.isRecalcReady,
      isRecalcReady = _ref$isRecalcReady === void 0 ? false : _ref$isRecalcReady;

  var handleChange = function handleChange(e) {
    e.preventDefault();
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;
    onMetadataChange({
      name: name,
      value: value,
      imageIndex: imageIndex
    });
  };

  var handleRecalcClick = function handleRecalcClick(e) {
    e.stopPropagation();
    onRecalcClick({
      imageId: imageId
    });
  };

  var pageNumber = metadata === null || metadata === void 0 ? void 0 : (_metadata$find = metadata.find) === null || _metadata$find === void 0 ? void 0 : (_metadata$find$call = _metadata$find.call(metadata, function (md) {
    return md.key === 'pageNumber';
  })) === null || _metadata$find$call === void 0 ? void 0 : _metadata$find$call.value;
  return React.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: classnames('ps-page-thumbnail', {
      'ps-page-thumbnail-is-active': isActive
    }),
    onClick: onClick
  }, isLocked && React.createElement(Locker, null), error && React.createElement(Errorer, {
    errorMessage: error.message
  }), React.createElement("div", {
    className: "ps-page-thumbnail-image-wrapper"
  }, isRecalcReady && React.createElement("div", {
    className: "ps-page-thumbnail-recalc-wrapper"
  }, React.createElement("button", {
    className: "recalc-button",
    onClick: handleRecalcClick
  }, "Extract")), React.createElement("img", {
    src: src,
    alt: "",
    className: "ps-page-thumbnail-image"
  }), React.createElement("div", {
    className: "page-number-wrapper"
  }, pageNumber !== undefined && !showMetadata && React.createElement("span", {
    className: "page-number"
  }, pageNumber))), React.createElement("div", {
    className: "ps-page-thumbnail-metadata-wrapper"
  }, metadata.map(function (_ref2) {
    var _metadataConfigs$find;

    var key = _ref2.key,
        value = _ref2.value;
    return React.createElement(React.Fragment, null, React.createElement("label", {
      for: key
    }, key), React.createElement("input", {
      type: "text",
      value: value,
      name: key,
      onChange: handleChange,
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      id: key,
      list: "".concat(key, "-list")
    }), React.createElement("datalist", {
      id: "".concat(key, "-list")
    }, (_metadataConfigs$find = metadataConfigs.find(function (mcf) {
      return mcf.key === key;
    })) === null || _metadataConfigs$find === void 0 ? void 0 : _metadataConfigs$find.options.map(function (opt) {
      return React.createElement("option", {
        key: opt,
        value: opt
      });
    })));
  })));
}

function isLocked(page) {
  var _Date$parse;

  var lockedUntil = page.lockedUntil; // needs to be defined and greater than current time

  if (((_Date$parse = Date.parse(lockedUntil)) === null || _Date$parse === void 0 ? void 0 : _Date$parse.valueOf()) > new Date().valueOf()) {
    return true;
  }

  return false;
}

function PageSelector(_ref3) {
  var pages = _ref3.pages,
      onPageClick = _ref3.onPageClick,
      onMetadataChange = _ref3.onMetadataChange,
      metadataConfigs = _ref3.metadataConfigs,
      onRecalcClick = _ref3.onRecalcClick;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showMetadata = _useState2[0],
      setShowMetadata = _useState2[1];

  return React.createElement("div", {
    className: classnames('page-selector', {
      'page-selector--opened': showMetadata
    })
  }, React.createElement("div", {
    className: "top-buttons"
  }, React.createElement("div", {
    className: "show-metadata-wrapper"
  }, React.createElement("label", {
    className: "switch mr-2"
  }, React.createElement("input", {
    id: "show-metadata",
    type: "checkbox",
    value: showMetadata,
    onChange: function onChange() {
      return setShowMetadata(function (prev) {
        return !prev;
      });
    }
  }), React.createElement("span", {
    className: "slider round"
  })), React.createElement("label", null, "Metadata"))), React.createElement("div", {
    className: "pages"
  }, pages.map(function (page, idx) {
    return React.createElement(PageThumbnail, {
      key: "".concat(page.id),
      isLocked: isLocked(page),
      error: page.syncError,
      src: page.src,
      isActive: page.isActive,
      onClick: function onClick() {
        return onPageClick(idx);
      },
      metadata: page.metadata,
      showMetadata: showMetadata,
      imageIndex: idx,
      imageId: page.id,
      onMetadataChange: onMetadataChange,
      metadataConfigs: metadataConfigs,
      onRecalcClick: onRecalcClick,
      isRecalcReady: page.isRecalcReady
    });
  })));
}

PageSelector.defaultProps = {
  onPageClick: function onPageClick() {},
  recalcActive: false,
  saveActive: false,
  pageNumber: undefined
};
export default PageSelector;